module.exports = __webpack_public_path__ + "img/cancelPhone.236ca196.png";